.ucs-occupation .ucs-hero-stage{max-width:1040px}
.ucs-occupation .ucs-hero-conversation>.ucs-output-table{margin-inline:-8px}
.ucs-occupation .ucs-filter{padding-top:8px}
.ucs-occupation .ucs-table-scroll table{table-layout:fixed;min-width:0}
.ucs-occupation table th,.ucs-occupation table td{white-space:normal;overflow-wrap:anywhere}
.ucs-occupation .ucs-row-button{max-width:none;width:100%;font-size:12px;color:var(--text)}
.ucs-occupation .ucs-source-download{display:inline-flex;align-items:center;gap:7px;margin-top:16px;font-size:11px;text-decoration:underline;text-underline-offset:4px;min-height:36px}
.ucs-occupation .ucs-input-note{font-size:11px;line-height:1.5;margin-top:12px}
.ucs-output-references{margin-top:12px}
.ucs-output-references .ucs-blueprint-citations{gap:6px}
.ucs-output-references button{min-height:36px}
.ucs-output-source{margin-top:14px}
.ucs-output-source .ucs-blueprint-source{box-shadow:var(--shadow);border:1px solid var(--border)}
.ucs-output-references:not(.ucs-document .ucs-output-references):not(.ucs-chart .ucs-output-references):not(.ucs-gallery .ucs-output-references){padding:0 22px 20px}
.ucs-document{padding:2px 26px 26px}
.ucs-document>section{padding:19px 0;border-top:1px solid var(--border)}
.ucs-document>section:first-child{border-top:none}
.ucs-document-title{display:flex;align-items:center;gap:10px;margin-bottom:9px}
.ucs-document h4{font-size:15px;line-height:1.5}
.ucs-document p{font-size:13px;line-height:1.7;color:var(--muted)}
.ucs-output-checklist .ucs-document-title{color:var(--muted)}
.ucs-timeline-number{display:grid;place-items:center;border-radius:50%;width:27px;height:27px;background:var(--panel);font-size:12px;flex-shrink:0}
.ucs-chart{padding:8px 26px 26px}
.ucs-chart-row{margin-top:22px}
.ucs-chart-row>div:first-child{display:flex;align-items:center;justify-content:space-between;gap:12px;font-size:13px}
.ucs-chart-row strong{font-weight:500}
.ucs-chart-row>p{font-size:11px;margin-top:8px}
.ucs-chart-track{position:relative;height:16px;border-radius:5px;background:var(--panel);overflow:hidden;margin-top:10px}
.ucs-chart-track>span{display:block;height:100%;background:linear-gradient(90deg,var(--preview-accent),var(--preview-companion));border-radius:5px;transition:width .2s ease}
.ucs-code-output{min-width:0}
.ucs-code-language{padding:8px 24px;font-size:10px;letter-spacing:1px;text-transform:uppercase;color:var(--muted);background:var(--panel)}
.ucs-page .ucs-code{margin:0;padding:22px 24px;background:var(--panel);color:var(--text);font:12px/1.85 ui-monospace,SFMono-Regular,Menlo,monospace;overflow:auto;white-space:pre;max-width:100%;tab-size:2}
.ucs-file-preview .ucs-code{margin-top:16px}
.ucs-comparison{padding:0 24px 26px}
.ucs-comparison>div:not(.ucs-output-references){padding:18px;background:var(--panel);border:1px solid var(--border);border-radius:8px;margin-top:14px}
.ucs-comparison>div:nth-child(2){background:var(--panel);border-color:var(--border)}
.ucs-comparison p{margin-top:10px;white-space:pre-line;font-size:13px;color:var(--text)}
.ucs-gallery-rationale{padding:20px 24px}
.ucs-gallery-rationale>p{font-size:13px}
.ucs-gallery .ucs-artwork,.ucs-gallery-image{width:min(100% - 48px,420px);margin:0 auto;border-radius:5px;box-shadow:var(--shadow)}
.ucs-gallery-image{display:block;object-fit:contain;height:auto}
.ucs-artwork{position:relative;isolation:isolate;overflow:hidden;min-height:340px;aspect-ratio:4 / 5;background:#f4f0e6;color:#24352b;padding:29px;display:flex;flex-direction:column;justify-content:space-between;text-align:left}
.ucs-artwork-eyebrow{font-size:11px;letter-spacing:2.4px;text-transform:uppercase;z-index:1}
.ucs-artwork>strong{font-family:Georgia,serif;font-size:clamp(32px,4vw,60px);line-height:1.03;letter-spacing:-2px;font-weight:400;max-width:80%;white-space:pre-line;z-index:1;margin-top:auto;margin-bottom:25px}
.ucs-artwork-footer{font-size:10px;letter-spacing:1px;z-index:1}
.ucs-artwork-shapes{position:absolute;inset:0;z-index:0}
.ucs-artwork-shapes i{display:block;position:absolute;background:#7f9982;opacity:.68}
.ucs-artwork-shapes i:first-child{width:66%;height:62%;border-radius:50% 50% 0 0;right:-13%;top:13%;transform:rotate(-13deg)}
.ucs-artwork-shapes i:nth-child(2){height:35%;width:42%;border-radius:50%;right:3%;top:41%;background:#aabb9f}
.ucs-artwork-shapes i:nth-child(3){height:30%;width:34%;border-radius:50% 50% 0 0;right:16%;top:17%;background:#ded7bc}
.ucs-artwork-geometric{background:#e5ecdf}
.ucs-artwork-geometric .ucs-artwork-shapes i:first-child{border-radius:0;width:55%;height:70%;top:5%;right:-18%;transform:rotate(28deg)}
.ucs-artwork-geometric .ucs-artwork-shapes i:nth-child(2){border-radius:0;right:7%;top:30%;height:43%;width:43%;transform:rotate(28deg);background:#cabca3}
.ucs-artwork-geometric .ucs-artwork-shapes i:nth-child(3){background:#f4f0e6;height:38%;top:5%;right:20%;width:31%;transform:rotate(28deg);border-radius:0}
.ucs-deck{padding:0 24px 24px}
.ucs-slide-picker{display:flex;gap:7px;margin-bottom:16px;overflow:auto;padding:4px}
.ucs-slide-picker button{flex:1;min-width:110px;padding:12px 10px;border:1px solid var(--border);border-radius:7px;background:var(--panel);text-align:left;font-size:11px;line-height:1.5;min-height:54px}
.ucs-slide-picker button[aria-pressed=true]{background:var(--selected-bg);border-color:var(--selected-border)}
.ucs-slide-picker button>span{display:block;font-size:10px;color:var(--muted);margin-bottom:4px}
.ucs-slide{display:grid;grid-template-columns:minmax(0,1fr);border:1px solid var(--border);border-radius:8px;overflow:hidden;min-height:280px;background:var(--panel)}
.ucs-slide:has(.ucs-artwork){grid-template-columns:1fr 1.2fr}
.ucs-slide>.ucs-artwork{aspect-ratio:auto;min-height:280px;padding:22px}
.ucs-slide .ucs-artwork>strong{font-size:33px;letter-spacing:-1px}
.ucs-slide>div:not(.ucs-artwork){padding:28px;display:flex;flex-direction:column;justify-content:center}
.ucs-slide h4{font-size:25px;line-height:1.25;margin-top:12px}
.ucs-slide ul{padding-left:18px;margin:18px 0 0;font-size:13px;line-height:1.8;color:var(--muted)}
.ucs-slide li+li{margin-top:8px}
.ucs-more-prompts{border:1px solid var(--border);border-radius:12px;margin-top:24px;padding:20px}
.ucs-more-prompts>summary{display:flex;align-items:center;justify-content:space-between;gap:10px;min-height:44px;list-style:none;font-size:14px}
.ucs-extra-prompts{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;margin-top:20px}
.ucs-occupation .ucs-mini-paper .ucs-document,.ucs-occupation .ucs-mini-paper .ucs-chart,.ucs-occupation .ucs-mini-paper .ucs-comparison,.ucs-occupation .ucs-mini-paper .ucs-deck{padding:0}
.ucs-mini-paper .ucs-document>section{padding:12px 0}
.ucs-mini-paper .ucs-document h4{margin:0;font-size:12px}
.ucs-mini-paper .ucs-document p,.ucs-mini-paper .ucs-comparison p{font-size:11px}
.ucs-mini-paper .ucs-code{font-size:9px;padding:10px;line-height:1.7}
.ucs-mini-paper .ucs-code-language{padding:5px 10px}
.ucs-mini-paper .ucs-chart-row{margin-top:16px}
.ucs-mini-paper .ucs-chart-row>div:first-child{font-size:10px}
.ucs-mini-paper .ucs-gallery .ucs-artwork{width:100%;min-height:260px;padding:20px}
.ucs-mini-paper .ucs-artwork>strong{font-size:35px;letter-spacing:-1px}
.ucs-mini-paper .ucs-artwork-eyebrow{font-size:8px}
.ucs-mini-paper .ucs-slide{min-height:240px}
.ucs-mini-paper .ucs-slide:has(.ucs-artwork){grid-template-columns:1fr}
.ucs-mini-paper .ucs-slide>.ucs-artwork{min-height:170px}
.ucs-mini-paper .ucs-slide>div:not(.ucs-artwork){padding:14px}
.ucs-mini-paper .ucs-slide h4{font-size:15px;margin:10px 0}
.ucs-mini-paper .ucs-slide ul{font-size:10px;margin:4px 0 0}
.ucs-occupation .ucs-blueprint-source{min-width:0}
.ucs-occupation .ucs-blueprint-citations button{white-space:normal;text-align:left;line-height:1.4;min-height:44px}
.ucs-occupation .ucs-blueprint-choices button{min-height:44px}
@media(max-width:700px){.ucs-occupation .ucs-hero-conversation{padding:18px 14px}
.ucs-occupation .ucs-user-prompt{padding:14px}
.ucs-occupation .ucs-answer-heading h2{font-size:17px}
.ucs-occupation .ucs-completed{display:none}
.ucs-occupation table th,.ucs-occupation table td{padding:10px 6px;font-size:10px}
.ucs-occupation table th{font-size:10px}
.ucs-occupation .ucs-row-button{font-size:10px}
.ucs-document,.ucs-chart,.ucs-comparison,.ucs-deck{padding-inline:16px}
.ucs-page .ucs-code{font-size:10px;padding:16px}
.ucs-gallery .ucs-artwork,.ucs-gallery-image{width:calc(100% - 32px)}
.ucs-artwork{min-height:290px;padding:24px}
.ucs-artwork>strong{font-size:44px}
.ucs-slide:has(.ucs-artwork){grid-template-columns:1fr}
.ucs-slide>.ucs-artwork{min-height:210px;aspect-ratio:4 / 3}
.ucs-slide>div:not(.ucs-artwork){padding:22px}
.ucs-extra-prompts{grid-template-columns:1fr}
.ucs-occupation .ucs-blueprint-source blockquote{font-size:13px}
.ucs-occupation .ucs-output-heading{padding:18px 16px}
.ucs-occupation .ucs-source-download{min-height:44px}
.ucs-occupation .ucs-filter{padding-inline:12px}
.ucs-occupation .ucs-filter>button{min-height:44px}
.ucs-occupation .ucs-output-references:not(.ucs-document .ucs-output-references):not(.ucs-chart .ucs-output-references):not(.ucs-gallery .ucs-output-references){padding-inline:14px}}
@media(prefers-reduced-motion:reduce){.ucs-occupation .ucs-chart-track>span{transition:none}}
.ucs-occupation .ucs-faq details{padding:10px 0}
.ucs-occupation .ucs-faq summary{min-height:44px}
.ucs-occupation .ucs-full-prompt summary{min-height:44px;padding-block:10px;cursor:pointer}
.ucs-chart-target{position:absolute;top:0;bottom:0;width:3px;background:var(--surface);border-inline:1px solid var(--text);transform:translateX(-1px)}
.ucs-occupation .ucs-hero .ucs-gallery{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:18px 26px;align-items:center}
.ucs-occupation .ucs-hero .ucs-gallery>.ucs-filter{grid-column:1 / -1;margin-bottom:2px}
.ucs-occupation .ucs-hero .ucs-gallery>.ucs-artwork{width:100%;max-width:320px;min-height:320px;margin-inline:auto}
.ucs-occupation .ucs-hero .ucs-gallery-rationale{padding:0 18px 0 0}
.ucs-occupation .ucs-hero .ucs-gallery-rationale>p{font-size:15px}
.ucs-occupation .ucs-hero .ucs-artwork>strong{font-size:44px;max-width:100%;letter-spacing:-1.4px}
@media(max-width:700px){.ucs-occupation .ucs-hero .ucs-gallery{grid-template-columns:1fr;gap:18px}
.ucs-occupation .ucs-hero .ucs-gallery-rationale{padding:0 8px}
.ucs-occupation .ucs-hero .ucs-gallery>.ucs-artwork{width:calc(100% - 16px);min-height:280px;padding:20px}
.ucs-occupation .ucs-hero .ucs-artwork>strong,.ucs-occupation .ucs-gallery .ucs-artwork>strong{font-size:clamp(24px,7vw,40px);max-width:100%;letter-spacing:-1px}}
.ucs-occupation .ucs-artwork{container-type:inline-size}
.ucs-occupation .ucs-artwork>strong{font-size:clamp(24px,14cqw,52px);max-width:100%}
.ucs-occupation .ucs-hero .ucs-artwork>strong{font-size:clamp(24px,14cqw,44px)}
.ucs-occupation .ucs-slide .ucs-artwork>strong{font-size:clamp(22px,14cqw,33px)}
.ucs-occupation .ucs-mini-paper .ucs-artwork>strong{font-size:clamp(18px,13cqw,30px);letter-spacing:-.5px;max-width:100%}
.ucs-occupation .ucs-file,.ucs-occupation .ucs-filter>button,.ucs-occupation .ucs-source-download,.ucs-occupation .ucs-workflow-menu>button{min-height:44px}
.ucs-occupation .ucs-icon-button{width:44px;height:44px}
.ucs-occupation .ucs-chart-label{display:flex;align-items:center;justify-content:space-between;gap:12px;font-size:13px}
.ucs-occupation .ucs-chart-track{display:block}
.ucs-occupation .ucs-chart-metric{display:block;width:100%;min-height:44px;padding:4px 0;background:transparent;border:0;border-radius:6px;text-align:left;color:inherit;cursor:pointer}
.ucs-occupation .ucs-chart-metric[aria-expanded=true]{background:var(--selected-bg)}
.ucs-occupation .ucs-chart-metric:focus-visible{outline:2px solid var(--focus);outline-offset:5px}
.ucs-occupation .ucs-chart-detail{padding-top:10px}
.ucs-occupation .ucs-chart-detail>p{font-size:12px}
.ucs-occupation .ucs-chart>.ucs-output-footnote{padding:18px 0 0}
.ucs-occupation .ucs-mini-paper .ucs-chart-label{font-size:10px}

/* Keep full slide choices readable instead of clipping the next title on phones. */
.ucs-occupation .ucs-slide-picker{flex-wrap:wrap;overflow:visible}
.ucs-occupation .ucs-slide-picker button{flex:1 1 140px;min-width:0;overflow-wrap:anywhere}
.ucs-artifact{padding:0 22px 20px;min-width:0}
.ucs-artifact-window{overflow:hidden;border:1px solid var(--border);border-radius:12px;background:var(--surface)}
.ucs-artifact-frame{display:block;width:100%;border:0;background:var(--surface)}
.ucs-artifact-text{margin-top:14px;font-size:12px}
.ucs-artifact-text>summary{cursor:pointer;min-height:44px;display:flex;align-items:center;gap:8px}
.ucs-artifact-text .ucs-document{padding:4px 0}
.ucs-artifact-compact{padding:0;pointer-events:none}
.ucs-artifact-compact .ucs-artifact-window{height:300px}
.ucs-artifact-compact .ucs-artifact-frame{width:100%;transform:none}
@media(max-width:700px){.ucs-artifact{padding-inline:12px}
.ucs-artifact-compact{padding:0}}

/* Compact previews stay readable; the full workflow owns the live project. */
@media (max-width:700px) {
  .ucs-occupation .ucs-hero-conversation { padding: 12px; }
  .ucs-occupation .ucs-output-heading { padding-inline: 12px; }
  .ucs-gallery .ucs-artwork, .ucs-gallery-image { width: calc(100% - 24px); }
  .ucs-occupation .ucs-artifact { padding-inline: 12px; }
  .ucs-occupation .ucs-artifact-window { width: 100%; }
  .ucs-occupation .ucs-artifact-frame { width: 100%; }
  .ucs-occupation .ucs-mini-paper { padding: 12px; }
  .ucs-occupation .ucs-code { font-size: 13px; }
  .ucs-occupation table th, .ucs-occupation table td, .ucs-occupation .ucs-row-button { font-size: 13px; }
}
